<template>
    <v-container
        fluid
        class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('menu.promotions') }}
        </div>
        <v-card>
            <v-card-actions class="px-4 justify-space-between">
                <div class="d-flex align-center">
                    <date-range-field
                        class="mx-4"
                        v-model="filterDate"/>
                    <v-select
                        outlined
                        hide-details
                        v-model="filterActive"
                        append-icon="expand_more"
                        height="40px"
                        :menu-props="{
                            offsetY: true,
                        }"
                        :items="activeList"
                    />
                </div>
                <v-btn
                    class="font-weight-regular"
                    color="primary"
                    @click="createBanners">
                    {{ $t('button.createBanner') }}
                </v-btn>
            </v-card-actions>
            <banner-setting-list-view
                type="promotion"
                ref="bannerSettingListView"
                :banners="banners"/>
        </v-card>
    </v-container>
</template>

<script>
import PaginationMixin from '@/mixins/PaginationMixin'
import DateRangeField from '@/components/fields/DateRangeField'
import BannerSettingListView from '@/views/lists/BannerSettingListView'

import { mapGetters } from 'vuex'

export default {
    name: 'PromotionSettingListPage',

    mixins: [PaginationMixin],

    components: {
        DateRangeField,
        BannerSettingListView
    },

    data () {
        return {
            filterActive: 'All Status',
            filterDate: [],
            activeList: ['All Status', 'Active', 'InActive']
        }
    },

    computed: {
        ...mapGetters('appSettings', ['getBannerByActiveState']),
        banners () {
            const result = this.getBannerByActiveState(this.filterActive)
            const fromDate = this.filterDate?.[0] ?? null
            const toDate = this.filterDate?.[1] ?? null
            return result.filter(v => {
                const isMatchType = v.type === 'promotion'
                const updatedAt = new Date(v.updatedAt).toDateString()
                let isMatchDate = true
                if (fromDate && toDate) {
                    isMatchDate = new Date(updatedAt).getTime() >= new Date(fromDate).getTime() && new Date(updatedAt).getTime() <= new Date(toDate).getTime()
                }
                if (fromDate) {
                    isMatchDate = new Date(updatedAt).getTime() >= new Date(fromDate).getTime()
                }
                return isMatchDate && isMatchType
            })
        }

    },

    mounted () {
        this.fetchBanners()
    },

    methods: {
        fetchBanners () {
            this.$store.dispatch(
                'appSettings/fetchBanners'
            )
        },

        createBanners () {
            this.$refs.bannerSettingListView.createBanner()
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
